import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { CanView } from "components/Common/CanView"
import { ACCESS } from "constants/accessPermissions"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    const mm = new MetisMenu("#side-menu")
    activeMenu()

    const menuEl = document.getElementById("side-menu")

    const handleClick = e => {
      const link = e.target.closest("a")
      if (link && !link.classList.contains("has-arrow")) {
        if (window.innerWidth < 992) {
          // collapse all open menus
          const activeEls = menuEl.querySelectorAll(
            ".mm-active, .mm-show, .active"
          )
          activeEls.forEach(el => {
            el.classList.remove("mm-active", "mm-show", "active")
          })

          // 🔥 also close the sidebar drawer if you’re using one
          document.body.classList.remove("vertical-collpsed")
          document.body.classList.remove("sidebar-enable")
        }
      }
    }

    menuEl.addEventListener("click", handleClick)

    return () => {
      menuEl.removeEventListener("click", handleClick)
    }
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")}</li>

            {/* Dashboard */}
            <CanView access={[ACCESS.DASHBOARD.VIEW_DASHBOARD_PANEL]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Dashboard")}</span>
                </Link>
                <ul className="sub-menu">
                  <CanView access={[ACCESS.DASHBOARD.VIEW_DASHBOARD]}>
                    <li>
                      <Link to="/dashboard">{props.t("Default")}</Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>

            {/* Stock List */}
            <CanView access={[ACCESS.STOCK_PANEL.VIEW_PANEL]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-car"></i>
                  <span>{props.t("Vehicle Management")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/stock-list">{props.t("Stock List")}</Link>
                  </li>

                  <CanView access={[ACCESS.BRAND.VIEW_BRAND_LIST]}>
                    <li>
                      <Link to="/brand-list">{props.t("Brands")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.MODEL.VIEW_MODEL_LIST]}>
                    <li>
                      <Link to="/model-list">{props.t("Models")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.LOCATION.VIEW_LOCATION_LIST]}>
                    <li>
                      <Link to="/location-list">{props.t("Locations")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.STATUS.VIEW_STATUS_LIST]}>
                    <li>
                      <Link to="/status-list">{props.t("Statuses")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.COLOR.VIEW_COLOR_LIST]}>
                    <li>
                      <Link to="/color-list">{props.t("Colors")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.FEATURE.VIEW_FEATURE_LIST]}>
                    <li>
                      <Link to="/feature-list">{props.t("Features")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.PACKAGE.VIEW_PACKAGE_LIST]}>
                    <li>
                      <Link to="/package-list">{props.t("Packages")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.YEAR.VIEW_YEAR_LIST]}>
                    <li>
                      <Link to="/year-list">{props.t("Years")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.ENGINE_CC.VIEW_ENGINE_CC_LIST]}>
                    <li>
                      <Link to="/engine-cc-list">{props.t("Engine CCs")}</Link>
                    </li>
                  </CanView>
                  <CanView
                    access={[ACCESS.CHASSIS_CODE.VIEW_CHASSIS_CODE_LIST]}
                  >
                    <li>
                      <Link to="/chassis-code-list">
                        {props.t("Chassis Codes")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.ENGINE_CODE.VIEW_ENGINE_CODE_LIST]}>
                    <li>
                      <Link to="/engine-code-list">
                        {props.t("Engine Codes")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.FUEL_TYPE.VIEW_FUEL_TYPE_LIST]}>
                    <li>
                      <Link to="/fuel-type-list">{props.t("Fuel Types")}</Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.ENGINE_TYPE.VIEW_ENGINE_TYPE_LIST]}>
                    <li>
                      <Link to="/engine-type-list">
                        {props.t("Engine Types")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.KEY_TYPE.VIEW_KEY_TYPE_LIST]}>
                    <li>
                      <Link to="/key-type-list">{props.t("Key Types")}</Link>
                    </li>
                  </CanView>
                  <CanView
                    access={[ACCESS.AUCTION_GRADE.VIEW_AUCTION_GRADE_LIST]}
                  >
                    <li>
                      <Link to="/auction-grade-list">
                        {props.t("Auction Grades")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView
                    access={[ACCESS.TRANSMISSION.VIEW_TRANSMISSION_LIST]}
                  >
                    <li>
                      <Link to="/transmission-list">
                        {props.t("Transmissions")}
                      </Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>

            {/* Vehicle Movement Group */}
            <CanView access={[ACCESS.VEHICLE_MOVEMENT_PANEL.VIEW]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-transfer-alt"></i>
                  <span>{props.t("Vehicle Movement")}</span>
                </Link>
                <ul className="sub-menu">
                  <CanView access={[ACCESS.VEHICLE_MOVEMENT.VIEW_LIST]}>
                    <li>
                      <Link to={"/vehicle-movement-list?tab=movement-list"}>
                        {props.t("Movement List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.VEHICLE_MOVEMENT.VIEW_KEY_LIST]}>
                    <li>
                      <Link to={"/vehicle-movement-list?tab=key-list"}>
                        {props.t("Movement Key List")}
                      </Link>
                    </li>
                  </CanView>

                  <CanView access={[ACCESS.VEHICLE_MOVEMENT_TYPE.VIEW_LIST]}>
                    <li>
                      <Link to="/vehicle-movement-type-list">
                        {props.t("Movement Type List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.LOCATION.VIEW_LOCATION_LIST]}>
                    <li>
                      <Link to="/movement-location-list">
                        {props.t("Location List")}
                      </Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>
            {/* Vehicle Fuel Group */}
            <CanView access={[ACCESS.VEHICLE_FUEL_PANEL.VIEW]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="fas fa-gas-pump"></i>
                  <span>{props.t("Vehicle Fuel")}</span>
                </Link>
                <ul className="sub-menu">
                  <CanView access={[ACCESS.VEHICLE_FUEL_USE.VIEW_LIST]}>
                    <li>
                      <Link to="/fuel-usage-list">
                        {props.t("Fuel Usage List")}
                      </Link>
                    </li>
                  </CanView>

                  <CanView access={[ACCESS.VEHICLE_FUEL_STOCK.VIEW_LIST]}>
                    <li>
                      <Link to={"/purchased-fuel-list"}>
                        {props.t("Purchased Fuel List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.LOCATION.VIEW_LOCATION_LIST]}>
                    <li>
                      <Link to="/fuel-station-list">
                        {props.t("Fuel Station List")}
                      </Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>

            {/* Content Manager */}
            <CanView access={[ACCESS.CONTENT_MANAGER.VIEW_CONTENT_MANAGER]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-notepad"></i>
                  <span>{props.t("Content Manager")}</span>
                </Link>
                <ul className="sub-menu">
                  <CanView
                    access={[ACCESS.CONTENT_MANAGER.VIEW_VEHICLE_CONTENT_LIST]}
                  >
                    <li>
                      <Link to="/vehicle-content-list">
                        {props.t("Vehicle Content List")}
                      </Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>

            {/* Customer */}
            <CanView access={[ACCESS.CUSTOMER_PANEL.VIEW]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-group"></i>
                  <span>{props.t("Customer")}</span>
                </Link>
                <ul className="sub-menu">
                  <CanView access={[ACCESS.CUSTOMER.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-list">
                        {props.t("Customer List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.CUSTOMER_DESIGNATION.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-designation-list">
                        {props.t("Designation List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.CUSTOMER_DESIGNATION.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-department-list">
                        {props.t("Department List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.CUSTOMER_COMPANY.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-company-list">
                        {props.t("Company List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.CUSTOMER_AREA.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-area-list">
                        {props.t("Area List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.CUSTOMER_CITY.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-city-list">
                        {props.t("City List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.CUSTOMER_TYPE.VIEW_LIST]}>
                    <li>
                      <Link to="/customer-type-list">
                        {props.t("Customer Type List")}
                      </Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>

            {/* Accessories */}
            <CanView access={[ACCESS.ACCESSORIES_MANAGEMENT.VIEW]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-box"></i>
                  <span>{props.t("Accessories")}</span>
                </Link>
                <ul className="sub-menu">
                  <CanView access={[ACCESS.ACCESSORIES_USAGE.VIEW_LIST]}>
                    <li>
                      <Link to="/accessories-usage-list">
                        {props.t("Usage List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.ACCESSORIES_STOCK.VIEW_LIST]}>
                    <li>
                      <Link to="/accessories-stock-list">
                        {props.t("Stock List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.ACCESSORIES.VIEW_LIST]}>
                    <li>
                      <Link to="/accessories-list">
                        {props.t("Accessories List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.ACCESSORIES_COMPANY.VIEW_LIST]}>
                    <li>
                      <Link to="/accessories-store-list">
                        {props.t("Store List")}
                      </Link>
                    </li>
                  </CanView>
                  <CanView access={[ACCESS.UNIT.VIEW_LIST]}>
                    <li>
                      <Link to="/accessories-unit-list">
                        {props.t("Unit List")}
                      </Link>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>

            {/* Importer List */}
            <CanView
              access={[ACCESS.VEHICLE_IMPORTER.VIEW_VEHICLE_IMPORTER_LIST]}
            >
              <li>
                <Link to="/importer-list">
                <i className="bx bx-store"></i>
                <span>{props.t("Importer List")}</span>
                </Link>
              </li>
            </CanView>

            {/* Message List */}
            <CanView access={[ACCESS.MESSAGE.VIEW_CONTACT_MESSAGE_LIST]}>
              <li>
                <Link to="/message-list">
                  <i className="bx bx-envelope"></i>
                  <span>{props.t("Message List")}</span>
                </Link>
              </li>
            </CanView>

            {/* Settings */}
            <CanView access={[ACCESS.SETTINGS.VIEW_SETTINGS_PANEL]}>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-cog"></i>
                  <span>{props.t("Settings")}</span>
                </Link>

                <ul className="sub-menu">
                  {/* Showroom List */}
                  <CanView access={[ACCESS.SHOWROOM.VIEW_SHOWROOM_LIST]}>
                    <li>
                      <Link to="/showroom-list">
                        {props.t("Showroom List")}
                      </Link>
                    </li>
                  </CanView>

                  {/* User List */}
                  <CanView access={[ACCESS.USER.VIEW_USER_LIST]}>
                    <li>
                      <Link to="/user-list">{props.t("User List")}</Link>
                    </li>
                  </CanView>

                  {/* Role Permission Group */}
                  <CanView
                    access={[ACCESS.ROLE_PERMISSION.VIEW_ROLE_PERMISSION]}
                  >
                    <li>
                      <Link to="/#" className="has-arrow">
                        {props.t("Role Permission")}
                      </Link>
                      <ul className="sub-menu">
                        <CanView access={[ACCESS.MODULE.VIEW_MODULE_LIST]}>
                          <li>
                            <Link to="/module-list">
                              {props.t("Module List")}
                            </Link>
                          </li>
                        </CanView>
                        <CanView
                          access={[ACCESS.PERMISSION.VIEW_PERMISSION_LIST]}
                        >
                          <li>
                            <Link to="/permission-list">
                              {props.t("Permission List")}
                            </Link>
                          </li>
                        </CanView>

                        <CanView access={[ACCESS.ROLE.VIEW_ROLE_LIST]}>
                          <li>
                            <Link to="/role-list">{props.t("Role List")}</Link>
                          </li>
                        </CanView>
                      </ul>
                    </li>
                  </CanView>
                </ul>
              </li>
            </CanView>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
